import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import React from 'react';

const styles = xcss({
	gridArea: 'breadcrumbs',
	marginBlockEnd: 'space.050',
	minWidth: '0',
});

export const Breadcrumbs = ({ children }: React.PropsWithChildren<unknown>) => {
	return <Box xcss={styles}>{children}</Box>;
};
